import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-fieldset-1-6-0{margin:0 0 24px;padding:0;border:0}@media (min-width:1200px){.hcr-fieldset-1-6-0{margin:0 0 24px}}.hcr-fieldset-1-6-0 .hcr-fieldset__item-1-6-0{margin-top:12px;margin-bottom:0}.hcr-fieldset__info-1-6-0{color:#444;font-size:14px;font-weight:300;line-height:17px;display:block;padding-top:3px}.hcr-fieldset--error-1-6-0 .hcr-fieldset__info-1-6-0{color:#c64300}",
map:{"hcr-fieldset":"hcr-fieldset-1-6-0","hcr-fieldset__item":"hcr-fieldset__item-1-6-0","hcr-fieldset__info":"hcr-fieldset__info-1-6-0","hcr-fieldset--error":"hcr-fieldset--error-1-6-0"}};

var bem = Bem('fieldset', styles);
var Fieldset = function Fieldset(_ref) {
  var extraClasses = _ref.extraClasses,
      children = _ref.children,
      valid = _ref.valid,
      info = _ref.info,
      rest = _objectWithoutProperties(_ref, ["extraClasses", "children", "valid", "info"]);

  return React.createElement("fieldset", _extends({
    className: bem.b({
      error: valid === false
    }, extraClasses)
  }, rest), children.length ? children.map(function (child, i) {
    return React.createElement("div", {
      key: child.key || i,
      className: bem.e('item')
    }, child);
  }) : children, info && React.createElement("span", {
    className: bem.e('info')
  }, info));
};
Fieldset.displayName = 'Fieldset';
Fieldset.defaultProps = {
  extraClasses: '',
  valid: null,
  info: null
};
Fieldset.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Children are required */
  children: PropTypes.node.isRequired,

  /** Controls appearance of info text, shows it as error if set to false */
  valid: PropTypes.bool,

  /** Provides extra information for the fieldset */
  info: PropTypes.string
};
var fieldset = Injecss(Fieldset, styles);

export { fieldset as Fieldset };
